import React from "react";
import SpanRequired from "./SpanRequired";

const LabelForm = (props) => {
  const { required, className, text, onClick, htmlFor, children } = props;
  const labelClass = `font-medium flex items-center ${className || ""}`;
  return (
    <label
      className={labelClass}
      htmlFor={htmlFor ? htmlFor : null}
      onClick={onClick ? onClick : null}
    >
      {text ? text : children}
      {required && <SpanRequired />}
    </label>
  );
};

export default LabelForm;
